import { ErrorBoundary as DataDogErrorBoundry } from '@datadog/rum-react-integration';
import React, { FC } from 'react';
import { APP_CRASH_KEY } from 'constant';
import { logger } from 'services';

const defaultOnError = (error: Error, info) => {
  logger.error(`${APP_CRASH_KEY}: Component error`, {
    error,
    info,
  });
};

export const ErrorBoundary: FC<{
  fallback?: () => React.ReactNode;
  onError?: () => void;
  children: React.ReactNode;
}> = ({ fallback, onError, children }) => {
  const reactFallback = fallback ? fallback() : null;
  const _fallback = (error: Error) => {
    const appCrashError = {
      ...error,
      message: `${APP_CRASH_KEY}: ${error.message}`,
    };

    if (onError) {
      onError();
    } else {
      defaultOnError(appCrashError, error.stack);
    }

    return reactFallback;
  };

  return (
    <DataDogErrorBoundry fallback={_fallback}>{children}</DataDogErrorBoundry>
  );
};
